export default __webpack_public_path__ + "static/rencipe-homepage-simplified-bdb715aeec227bbe03b2033109efec23.png";